import { withInstall as o } from "../../utils/with-install.js";
import r from "./checkbox-group.vue.js";
o(r);
